import styled from '@emotion/styled';
import { COLORS } from '../../constants';

export const StyledInput = styled.input`
  min-width: 533px;
  border: 0px;
  outline: none;
  border-bottom: 1px solid #c8c8c8;
  font-size: 16px;
`;

export const StyledNameInputWrapper = styled.div`
  position: relative;
  padding-bottom: 27px;
  font-size: 16px;
`;

export const StyledInputTitle = styled.span`
  font-weight: 700;
  margin-right: 5px;
`;

export const StyledInputCounter = styled.span`
  width: 27px;
  height: 14px;
  position: absolute !important;
  top: 27px;
  right: 0;

  text-align: right;
  font-size: 10px;
  color: rgba(200, 200, 200, 0.9);

  span {
    color: ${COLORS.venetianRed};
  }
`;
